import React, { Component } from 'react';
import axios from 'axios'

import { MainHeader } from '../Components'

import MapsHeader from './_MapsHeader'
import MapsHelpers from './_MapsHelpers'
import MapsPlanDetails from './_MapsPlanDetails'
import MapsDroneLayerDetails from './_MapsDroneLayerDetails'
import MapsShapeDetails from './_MapsShapeDetails'

import Maps from './_Maps'
import MapsPoint from './_MapsPoint'
import MapsLine from './_MapsLine'
import MapsPolygon from './_MapsPolygon'
import MapsLengthMarker from './_MapsLengthMarker'
import MapsDroneLayer from './_MapsDroneLayer'

import MapsDrawingTools from './_MapsDrawingTools'
import MapsMenu from './_MapsMenu'
import PlanDetailsSave from './_PlanDetailsSave'

import ShareDialog from './_ShareDialog'
import SavingModal from './_MapsSavingModal'
import HelpAndFeedbackModal from './_HelpAndFeedbackModal'

import Plan from '../Models/Plan'
import PlanShape from '../Models/PlanShape'
import DroneLayer from '../Models/DroneLayer'

import firebase from '../Configs/firebase'
import Config from '../Configs/staticConfig'

import './Css/Maps.css'

class PageMaps extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPlan: null,
            currentDroneLayer: null,
            mapType: 'satellite',
            isLoaded: false,
            isDrawed:false,
            isEdited:false,
            isShowMenu:true,
            selectedShape:null,
            isSaved:false,
            deleteShapes:[],
            isOpenShareDialog:false,
            isOpenSavingModal:false,
            isOpenHelpAndFeedback:false
        }

        this.findMyLocation = this.findMyLocation.bind(this)
        this.switchMapTypes = this.switchMapTypes.bind(this)
        this.getPlan = this.getPlan.bind(this)
        this.getDroneLayer = this.getDroneLayer.bind(this)
        this.firebaseGetPlan = this.firebaseGetPlan.bind(this)
        this.firebaseGetPlanShape = this.firebaseGetPlanShape.bind(this)
        this.firebaseGetDroneLayer = this.firebaseGetDroneLayer.bind(this)
        
        this.setDefault = this.setDefault.bind(this)
        this.setCurrentPlan = this.setCurrentPlan.bind(this)
        this.setCurrentDroneLayer = this.setCurrentDroneLayer.bind(this)
        this.setShowMenu = this.setShowMenu.bind(this)
        this.setSelectedShape = this.setSelectedShape.bind(this)
        this.setSaved = this.setSaved.bind(this)
        this.setEdited = this.setEdited.bind(this)
        this.setLoaded = this.setLoaded.bind(this)

        this.deleteShape = this.deleteShape.bind(this)
        this.setIsOpenShareDialog = this.setIsOpenShareDialog.bind(this)
        this.setIsOpenSavingModal = this.setIsOpenSavingModal.bind(this)
        this.setIsOpenHelpAndFeedback = this.setIsOpenHelpAndFeedback.bind(this)

        this.childMapsRef = React.createRef()
        this.db = firebase.firestore()
        this.mutablePlan = null
        this.prevPlan = null
    }

    componentWillReceiveProps(nextProps){
        const { planId, droneId } = nextProps.match.params
        const { path } = nextProps.match
        if(this.props !== nextProps){
            this.setState({isLoaded:true})
            if ( planId !== undefined ) {
                this.setDefault(null)
                this.getPlan(planId)
            }
            else if ( droneId !== undefined ) {
                this.setDefault(null)
                this.getDroneLayer(droneId);
            }
            else if ( path === '/mymap'){
                this.setDefault(this.state.currentDroneLayer)
                this.setState({isLoaded:true})
                return this.setState({
                    isShowMenu:false,
                    isDrawed:true,
                })
            }
            this.setState({
                isShowMenu:false,
                isDrawed:false
            })
        }
    }

    shouldComponentUpdate(prevState){
        if(prevState !== this.state) return true
    }

    componentDidUpdate(){
        if(this.state.currentPlan === null){
            this.setState({currentPlan:new Plan()})
        }
    }

    componentWillMount(){
        var a = document.getElementById('aTag')
        var banner = document.getElementById('divBanner')
    
        var isMobile = /iPhone|iPad|iPod|android/i.test(navigator.userAgent);
        if (isMobile) {
            var body = {
                longDynamicLink: Config.getLongDynamicLink(window.location)
            }
            return axios.post(Config.getCreateDynamicLinkUrl(),body)
            .then(res=>{
                a.setAttribute("href", res.data.shortLink)
                banner.style.display='block'
            })
        }
    }

    componentDidMount() {
        const { planId, droneId } = this.props.match.params;
        if ( planId !== undefined ) {
            this.setDefault(null)
            this.getPlan(planId);
        }
        else if ( droneId !== undefined ) {
            this.setDefault(null)
            this.getDroneLayer(droneId);
        }
        else{
            if( this.state.currentPlan === null){
                var plan = new Plan()
                this.setState({
                    currentPlan:plan,
                    isLoaded:true
                })
            }
            this.setState({isDrawed:true})
        }
    }

    findMyLocation() {
        this.childMapsRef.current.findMyLocation()
    }

    switchMapTypes() {
        this.setState((prevState) => ({
            mapType: ( prevState.mapType === 'satellite' ) ? 'roadmap' : 'satellite'
        }));
    }

    getPlan(id) {
        var plan = null;
        this.setDefault(null)
        this.firebaseGetPlan(id)
        .then((docSnapshot) => {
            if ( !docSnapshot.exists ) {
                return
            }
            plan = Plan.initBySnapshot(docSnapshot)
            return plan
        })
        .then((plan)=>{
            var body = {
                uid:[plan.userUid]
            }
            return axios.post(Config.getDisplaynameAndPhotoRequestURL(),body)
        })
        .then(res=>{
            plan = plan.setUserOwnerName(res.data[plan.userUid].displayName)
        })
        .then(()=>{
            return this.firebaseGetPlanShape(id);
        })
        .then((querySnapshot) => {
            querySnapshot.forEach((docSnapshot) => {
                const shape = PlanShape.initBySnapshot(docSnapshot);
                plan.shapesArray.push(shape);
            });
        })
        .catch((error) => {
            console.log(error);
        })
        .then(() => {
            if ( plan === null ) {
                // Load unfounded plan
                this.setState({
                    currentPlan: false,
                    isLoaded: true
                });
                return;
            }
            else if ( plan.droneLayersArray.length > 0 ) {
                // Load plan with drone layer (next process)
                this.mutablePlan = plan;
                this.getDroneLayer(plan.droneLayersArray[0].uid);
                return;
            }

            // Load plan
            this.setState({
                currentPlan: plan,
                isLoaded: true
            });
            this.childMapsRef.current.navigateToPlan(plan);
        });
    }

    getDroneLayer(id) {
        var droneLayer = null;
        this.firebaseGetDroneLayer(id)
        .then((docSnapshot) => {
            if ( !docSnapshot.exists ) {
                return;
            }
            droneLayer = DroneLayer.initBySnapshot(docSnapshot)
            return droneLayer
        })
        .then((droneLayer)=>{
            var body = {
                uid:[droneLayer.userUid]
            }
            return axios.post(Config.getDisplaynameAndPhotoRequestURL(),body)
        })
        .then(res=>{
            droneLayer = droneLayer.setUserOwnerName(res.data[droneLayer.userUid].displayName)
        })
        .catch((error) => {
            console.log(error);
        })
        .then(() => {
            if ( this.mutablePlan !== null ) {
                // Load plan with drone layer
                if ( droneLayer !== null ) {
                    this.mutablePlan.droneLayersArray[0] = droneLayer;
                }
                this.setState({
                    currentPlan: this.mutablePlan,
                    isLoaded: true
                });
                setTimeout(() => {
                    this.mutablePlan = null;
                }, 3000);
                this.childMapsRef.current.navigateToPlan(this.mutablePlan);
                return;
            }
            else if ( droneLayer === null ) {
                // Load unfounded drone layer
                this.setState({
                    currentDroneLayer: false,
                    isLoaded: true
                });
                return;
            }

            // Load drone layer
            this.setState({
                currentDroneLayer: droneLayer,
                isLoaded: true
            });
            this.childMapsRef.current.navigateToDroneLayer(droneLayer);
        });
    }

    firebaseGetPlan(id) {
        return this.db.collection('plans').doc(id).get();
    }

    firebaseGetPlanShape(id) {
        return this.db.collection('shapes').where('plan', '==', id).get();
    }

    firebaseGetDroneLayer(id) {
        return this.db.collection('drones').doc(id).get();
    }

    setCurrentPlan(plan){ 
        this.setState({currentPlan:plan})
    }

    setCurrentDroneLayer(droneLayer){
        if(droneLayer === null){
            window.mapRef.overlayMapTypes.clear()
        }
        this.setState({currentDroneLayer:droneLayer})
    }

    setShowMenu(bool){
        this.setState({isShowMenu:bool})
    }

    setSelectedShape(shape){
        this.setState({selectedShape:shape})
    }

    setSaved(bool){
        this.setState({isSaved:bool})
    }

    setLoaded(bool){
        this.setState({isLoaded:bool})
    }

    setEdited(bool){
        const { currentPlan } = this.state
        if(bool){
            this.setState({
                isEdited:bool
            })
            this.prevPlan = currentPlan
        }
        else{
            this.setState({
                isEdited:bool
            })
            this.prevPlan = null
        } 
    }

    deleteShape(shape){
        const {deleteShapes} = this.state
        deleteShapes.push(shape)
        this.setState({deleteShapes:deleteShapes})
    }

    setIsOpenShareDialog(bool){
        this.setState({
            isOpenShareDialog:bool
        })        
    }

    setIsOpenSavingModal(bool){
        this.setState({
            isOpenSavingModal:bool
        })        
    }

    setIsOpenHelpAndFeedback(bool){
        this.setState({
            isOpenHelpAndFeedback:bool
        })
    }

    setDefault(droneLayer){
        this.setState({
            currentPlan: null,
            currentDroneLayer: droneLayer,
            isLoaded: false,
            isDrawed:false,
            isShowMenu:false,
            selectedShape:null,
            isSaved:false,
            deleteShapes:[],
            isOpenShareDialog:false,
            isOpenSavingModal:false,
            isOpenHelpAndFeedback:false
        })
        this.prevPlan = null

    }

    render(){
        const { currentPlan, currentDroneLayer, mapType, isLoaded, isShowMenu, selectedShape, isDrawed, isSaved, deleteShapes, isEdited, isOpenShareDialog, isOpenSavingModal, isOpenHelpAndFeedback } = this.state;
        const { user } = this.props

        var shapeOutput = null
        var markerOutput = null
        var droneLayerOutput = null
        var lengthMarkersOutput = null
        var drawingMode = null
        var userMenu = null
        var taskAdding = null
        var planDetailAdding = null
        var detailsOutput = null
        var mapHeader = <MapsHeader/>

        var isMobile = /iPhone|iPad|iPod|android/i.test(navigator.userAgent);
        if( !isMobile ){
            mapHeader =  <MainHeader user={this.props.user}/>
        }
        userMenu =  <MapsMenu isShowMenu={isShowMenu} setShowMenu={this.setShowMenu} user={user} isEdited = {isEdited} setEdited={this.setEdited} currentPlan={currentPlan} setCurrentPlan={this.setCurrentPlan} deleteShapes={deleteShapes} isDrawed={isDrawed} getPlan={this.getPlan} setSelectedShape={this.setSelectedShape} setCurrentDroneLayer={this.setCurrentDroneLayer} setLoaded={this.setLoaded} setIsOpenSavingModal={this.setIsOpenSavingModal} setIsOpenHelpAndFeedback={this.setIsOpenHelpAndFeedback}/>

        if(currentPlan !== undefined && currentPlan !== null &&currentPlan !== false && currentPlan.shapesArray !== [] ){
            if (currentPlan.droneLayersArray.length > 0){
                const droneLayer = currentPlan.droneLayersArray[0]
                droneLayerOutput = <MapsDroneLayer droneLayer={droneLayer} user={user} />
            }

            shapeOutput = currentPlan.shapesArray.map((shape) => {
                switch (shape.type) {
                    case 'marker':
                        return (
                            <MapsPoint key={`${shape.uid}_${shape.key}`} coord={shape.coordsArray[0]} currentPlan={currentPlan} setCurrentPlan={this.setCurrentPlan} setSelectedShape={this.setSelectedShape} deleteShape={this.deleteShape} selectedShape={selectedShape} isDrawed={isDrawed} isEdited={isEdited}/>
                        )

                    case 'polyline':
                        if( selectedShape !== null && shape === selectedShape[0] ){
                            lengthMarkersOutput = shape.allLengthTuples().map((coordsTuple, index) => {
                                return (
                                    <MapsLengthMarker key={`${shape.uid}_l${index}`} coordsTuple={coordsTuple} mapType={mapType} />
                                )
                            })
                        }
                        return (
                            <React.Fragment key={`${shape.uid}_${shape.key}`}>
                                <MapsLine coordsArray={shape.coordsArray} mapType={mapType} currentPlan={currentPlan} setCurrentPlan={this.setCurrentPlan} setSelectedShape={this.setSelectedShape} deleteShape={this.deleteShape} selectedShape={selectedShape} isDrawed={isDrawed} isEdited={isEdited}/>
                                { lengthMarkersOutput }
                            </React.Fragment>
                        )
                    default:
                        if( selectedShape !== null && shape === selectedShape[0] ){
                            lengthMarkersOutput = shape.allLengthTuples().map((coordsTuple, index) => {
                                return (
                                    <MapsLengthMarker key={`${shape.uid}_l${index}`} coordsTuple={coordsTuple} mapType={mapType} />
                                )
                            })
                        }
                        return (
                            <React.Fragment key={`${shape.uid}_${shape.key}`}>
                            <MapsPolygon  coordsArray={shape.coordsArray} mapType={mapType} currentPlan={currentPlan} setCurrentPlan={this.setCurrentPlan} setSelectedShape={this.setSelectedShape} deleteShape={this.deleteShape} selectedShape={selectedShape} isDrawed={isDrawed} isEdited={isEdited}/>
                                { lengthMarkersOutput }                                
                            </React.Fragment>                            
                        )
                }
            })
            if ( currentPlan.markerCoord !== null ){
                markerOutput = <MapsPoint coord={currentPlan.markerCoord} isPlanMarker={true} currentPlan={currentPlan} setCurrentPlan={this.setCurrentPlan} setSelectedShape={this.setSelectedShape} deleteShape={this.deleteShape} selectedShape={selectedShape} isDrawed={isDrawed} isEdited={isEdited}/>
            }
        }
        
        if(currentDroneLayer !== undefined && currentDroneLayer !== null && isDrawed === false ){
            droneLayerOutput = <MapsDroneLayer droneLayer={currentDroneLayer} />
            detailsOutput = <MapsDroneLayerDetails droneLayer={currentDroneLayer} isLoaded={isLoaded} setCurrentPlan={this.setCurrentPlan} setCurrentDroneLayer={this.setCurrentDroneLayer} user={user} setIsOpenShareDialog={this.setIsOpenShareDialog}/>
        }

        if( isEdited ) detailsOutput = null
        else if ( !isEdited && isDrawed ) detailsOutput = null
        else if ( !isEdited && !isDrawed && currentDroneLayer === null) detailsOutput = <MapsPlanDetails plan={currentPlan} isLoaded={isLoaded} setCurrentPlan={this.setCurrentPlan} setCurrentDroneLayer={this.setCurrentDroneLayer} setEdited={this.setEdited} user={user} setIsOpenShareDialog={this.setIsOpenShareDialog}/>
        
        if(( user !== null && isDrawed === true ) || ( user !== null && isEdited === true )) drawingMode = <MapsDrawingTools isDrawed={isDrawed} setCurrentPlan={this.setCurrentPlan} currentPlan={currentPlan} getPlan={this.getPlan} setSaved={this.setSaved} setSelectedShape={this.setSelectedShape} />

        if( selectedShape !== null ){
            userMenu = null
            detailsOutput = <MapsShapeDetails isLoaded={isLoaded} selectedShape={selectedShape[0]} setShowMenu={this.setShowMenu} setSelectedShape={this.setSelectedShape} user={user} isEdited={isEdited} isDrawed={isDrawed} deleteShape={this.deleteShape} setCurrentPlan={this.setCurrentPlan} currentPlan={currentPlan} />
        } 
        
        if( isSaved ) detailsOutput = <PlanDetailsSave currentDroneLayer={currentDroneLayer} currentPlan={currentPlan} isShowMenu={isShowMenu} setShowMenu={this.setShowMenu} getPlan={this.getPlan} setSaved={this.setSaved} deleteShapes={deleteShapes} setCurrentDroneLayer={this.setCurrentDroneLayer} setEdited={this.setEdited} setSelectedShape={this.setSelectedShape} setLoaded={this.setLoaded} setIsOpenSavingModal={this.setIsOpenSavingModal}/>

        return (
            <div className="App PageMaps" style={{backgroundColor: '#444'}}>
                { mapHeader }
                <MapsHelpers findMyLocation={this.findMyLocation} switchMapTypes={this.switchMapTypes} />
                {drawingMode}
                {userMenu}
                {taskAdding}
                {planDetailAdding}
                <Maps isLoaded={isLoaded} mapType={mapType} ref={this.childMapsRef} setCurrentPlan={this.setCurrentPlan} currentPlan={currentPlan} setSelectedShape={this.setSelectedShape} selectedShape={selectedShape}>
                    { droneLayerOutput }
                    { shapeOutput }
                    { markerOutput }
                </Maps>
                { detailsOutput }
                <SavingModal isOpenSavingModal={isOpenSavingModal} setIsOpenSavingModal={this.setIsOpenSavingModal}/>
                <ShareDialog isOpenShareDialog={isOpenShareDialog} setIsOpenShareDialog={this.setIsOpenShareDialog}/>
                <HelpAndFeedbackModal isOpenHelpAndFeedback={isOpenHelpAndFeedback} setIsOpenHelpAndFeedback={this.setIsOpenHelpAndFeedback}></HelpAndFeedbackModal>
            </div>
        );
    }
}

export default PageMaps;


// WEBPACK FOOTER //
// ./src/PageMaps/index.js